const ROLLING_LABELS: Record<string, string | undefined> = {
  publish: "Approved",
  pending_review: "Pending",
  pending: "Pending",
  draft: "Draft",
  rejected: "Rejected",
  trash: "Trash",
  private: "Private",
  future: "Scheduled",
};

const TESTIMONIAL_LABELS: Record<string, string | undefined> = {
  APPROVED: "Approved",
  REJECTED: "Rejected",
  PENDING: "Pending",
};

/** A rolling submission's or its item's status as a badge label; null when there is no status. */
export function rollingStatusLabel(status: string | null): string | null {
  if (status === null) return null;
  return ROLLING_LABELS[status] ?? status;
}

/** A testimonial's status as a badge label; null when there is no status. */
export function testimonialStatusLabel(status: string | null): string | null {
  if (status === null) return null;
  return TESTIMONIAL_LABELS[status] ?? status;
}
